<script>
import Layout from "@/router/layouts/main";
import { mapState } from "vuex";
import { api } from "@/state/services";
import { required } from "vuelidate/lib/validators";

export default {
  locales: {
    pt: {
    },
    es: {
    }
  },
  components: {
    Layout,
  },
  computed: {
    ...mapState({
      account: state => state.account
    }),
  },
  data() {
    return {
      ip: null,

      statData: null,

      client: null,
      package: null,
      packages: null,

      choose: {
        modal: false,
        loading: false,
        id: "",
        type: "",
        types: [],
        name: "",
        description: "",
        value: "",
        discount: 0,
      },

      confirm: {
        loading: false,
        modal: false,
        zipcode: "",
        address: "",
        number: "",
        complement: "",
        district: "",
        city: "",
        state: "",
      },
    };
  },
  validations: {
    confirm: {
      zipcode: { required },
      address: { required },
      number: { required },
      complement: {},
      district: { required },
      city: { required },
      state: { required },
    },
  },
  methods: {
    getIp() {
      fetch('https://api.ipify.org?format=json')
        .then(response => response.json())
        .then(data => {
          if (data.ip) {
            this.ip = data.ip;
          }
        });
    },
    getPackages() {
      this.packages = null;

      api
        .get('packages')
        .then((response) => {
          if (response.data.status == 'success') {
            this.packages = response.data.list;
          }
        })
    },
    showChoose(pack) {
      this.choose.modal = false;
      this.choose.modal = true;
      this.choose.id = pack.id;
      this.choose.type = "";
      this.choose.types = pack.types;
      this.choose.name = pack.name;
      this.choose.description = pack.description;
      this.choose.value = pack.value;
      this.choose.discount = pack.discount;
    },
    choosePackage() {
      if (this.choose.id && this.choose.type) {
        this.choose.loading = true;

        api
          .post('packages/choose', {
            id: this.choose.id,
            type: this.choose.type,
          })
          .then((response) => {
            if (response.data.status == 'address') {
              this.choose.modal = false;

              this.confirm.modal = true;
              this.confirm.zipcode = '';
              this.confirm.address = '';
              this.confirm.number = '';
              this.confirm.complement = '';
              this.confirm.district = '';
              this.confirm.city = '';
              this.confirm.state = '';
            } else if (response.data.status == 'success') {
              this.choose.modal = false;
              this.choose.loading = false;
              this.$router.push('/packages/' + response.data.order.id);
            } else {
              this.choose.modal = false;
              this.choose.loading = false;
              this.confirm.modal = false;
              this.confirm.loading = false;
            }
          })
          .catch((error) => {
            if (error) {
              this.choose.modal = false;
              this.choose.loading = false;
            }
          })
          .finally(() => {
            this.choose.modal = false;
            this.choose.loading = false;
          });
      }
    },
    confirmPackage() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.confirm.loading = true;

      api
        .post('packages/buy', {
          id: this.choose.id,
          zipcode: this.confirm.zipcode,
          address: this.confirm.address,
          number: this.confirm.number,
          complement: this.confirm.complement,
          district: this.confirm.district,
          city: this.confirm.city,
          state: this.confirm.state,
        })
        .then((response) => {
          if (response.data.status == 'success') {
            this.confirm.modal = false;
            this.confirm.loading = false;
            this.$router.push('/packages/' + response.data.order.id);
          } else {
            this.alert.type = "alert-danger";
            this.alert.message = response.data.message;
          }
        })
        .catch((error) => {
          if (error) {
            this.alert.type = "alert-danger";
            this.alert.message = "Ocorreu um erro ao confirmar o pacote.";
          }
        })
        .finally(() => {
          this.confirm.loading = false;
        });
    },
    searchCep() {
      if (this.confirm.zipcode.length == 9) {
        api.get("https://cep.m2n.com.br/" + this.confirm.zipcode.replace(/\D/g, "")).then((response) => {
            if (response.data.address) {
              this.confirm.address = response.data.address;
            }
            if (response.data.district) {
              this.confirm.district = response.data.district;
            }
            this.confirm.city = response.data.city;
            this.confirm.state = response.data.state;
        });
      }
    },
  },
  mounted() {
    this.getPackages()
  }
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item"><router-link tag="a" to="/packages">Pacotes</router-link></li>
      <li class="breadcrumb-item d-none d-sm-block">Comprar</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Comprar</h3>
        <p></p>
      </div>
    </div>

    <div v-if="!packages" class="text-center">
      <b-spinner class="align-middle" variant="default" role="status"></b-spinner>
    </div>
    <div v-else-if="packages && packages.length > 0">
      <h5 class="mb-4">Escolha a melhor opção para você</h5>
      <div class="row">
        <div class="col-lg-4" v-for="(row, index) in packages" :key="index">
          <div class="card" :class="row.status == 'blocked' ? 'package-disabled' : ''">
            <div class="card-body text-center">
              <img v-if="row.cover" :src="row.cover" class="img-fluid mb-3" />
              <img v-else style="height:30px;" src="@/assets/images/plano.png" />
              <h4 class="mb-0 text-default">{{ row.name }}</h4>
              <p v-if="row.trackers == 1">{{ row.trackers }} localizador</p>
              <p v-else>{{ row.trackers }} localizadores</p>
              <h4 class="mb-3 text-dark">{{ row.value | currency }}</h4>
              <div class="mb-1 text-default" v-html="row.description"></div>
              <button class="btn btn-default btn-block btn-lg text-uppercase" v-on:click="showChoose(row)">
                Escolher
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="text-center">
      Nenhum pacote disponível no momento.
    </div>

    <b-modal v-model="choose.modal" modal-class="modal-bottom" hide-header hide-footer>
      <div>
        <h4>Confirmar escolha</h4>
        <p>Confirma a escolha do plano <strong>{{ choose.name }}</strong>?</p>
        <div class="mb-4 d-flex flex-gap-15">
          <div v-for="(row, index) in choose.types" :key="index">
            <div v-if="row == 'receive'">
              <b-form-radio v-model="choose.type" value="receive" class="package-type border rounded bg-soft-default">
                Envio do Localizador
              </b-form-radio>
            </div>
            <div v-else-if="row == 'loan'">
              <b-form-radio v-model="choose.type" value="loan" class="package-type border rounded bg-soft-default">
                Locação Inteligente
              </b-form-radio>
            </div>
          </div>
        </div>
        <div v-if="choose.type == 'receive'" class="mb-4">
          <h4>{{ parseFloat(choose.value) - parseFloat(choose.value * choose.discount) | currency }}</h4>
        </div>
        <div v-else-if="choose.type == 'loan'" class="mb-4">
          <h4>{{ choose.value | currency }}</h4>
        </div>
        <div v-else class="mb-4">
          <h4>R$ ---,--</h4>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <button class="btn btn-default btn-lg mr-3" v-on:click="choosePackage()" :disabled="this.choose.loading || !this.choose.type">
            Confirmar
            <b-spinner v-if="choose.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
          </button>
          <a class="btn btn-outline-link" v-on:click="choose.modal = false">Fechar</a>
        </div>
      </div>
    </b-modal>

    <b-modal v-model="confirm.modal" modal-class="modal-right" hide-header hide-footer>
      <div>
        <h4 class="mb-4">Confirme o seu endereço para entrega do localizador!</h4>
        <b-form @submit.prevent="confirmPackage">
          <b-form-group id="confirm.zipcode" label="CEP" label-for="confirm.zipcode">
            <b-form-input v-on:blur="searchCep()" id="confirm.zipcode" v-model="confirm.zipcode" type="text" inputmode="numeric" :class="{ 'is-invalid': $v.confirm.zipcode.$error }" autocomplete="off"
              v-mask="'#####-###'"></b-form-input>
            <div v-if="$v.confirm.zipcode.$error" class="invalid-feedback">
              <span v-if="!$v.confirm.zipcode.required">O CEP é obrigatório.</span>
              <span v-if="!$v.confirm.zipcode.invalid">O CEP informado é invalido.</span>
            </div>
          </b-form-group>
          <b-form-group id="confirm.address" label="Endereço" label-for="confirm.address">
            <b-form-input id="confirm.address" v-model="confirm.address" type="text" :class="{ 'is-invalid': $v.confirm.address.$error }" autocomplete="off"></b-form-input>
            <div v-if="$v.confirm.address.$error" class="invalid-feedback">
              <span v-if="!$v.confirm.address.required">O endereço é obrigatório.</span>
            </div>
          </b-form-group>
          <b-form-group id="confirm.number" label="Número" label-for="confirm.number">
            <b-form-input id="confirm.number" v-model="confirm.number" type="text" :class="{ 'is-invalid': $v.confirm.number.$error }" autocomplete="off"></b-form-input>
            <div v-if="$v.confirm.number.$error" class="invalid-feedback">
              <span v-if="!$v.confirm.number.required">O número é obrigatório.</span>
            </div>
          </b-form-group>
          <b-form-group id="confirm.complement" label="Complemento" label-for="confirm.complement">
            <b-form-input id="confirm.complement" v-model="confirm.complement" type="text" :class="{ 'is-invalid': $v.confirm.complement.$error }" autocomplete="off"></b-form-input>
            <div v-if="$v.confirm.complement.$error" class="invalid-feedback">
              <span v-if="!$v.confirm.complement.required">O complemento é obrigatório.</span>
            </div>
          </b-form-group>
          <b-form-group id="confirm.district" label="Bairro" label-for="confirm.district">
            <b-form-input id="confirm.district" v-model="confirm.district" type="text" :class="{ 'is-invalid': $v.confirm.district.$error }" autocomplete="off"></b-form-input>
            <div v-if="$v.confirm.district.$error" class="invalid-feedback">
              <span v-if="!$v.confirm.district.required">O bairro é obrigatório.</span>
            </div>
          </b-form-group>
          <b-form-group id="confirm.city" label="Cidade" label-for="confirm.city">
            <b-form-input id="confirm.city" class="bg-soft-info" v-model="confirm.city" type="text" :class="{ 'is-invalid': $v.confirm.city.$error }" autocomplete="off"
              readonly="readonly"></b-form-input>
            <div v-if="$v.confirm.city.$error" class="invalid-feedback">
              <span v-if="!$v.confirm.city.required">A cidade é obrigatória.</span>
            </div>
          </b-form-group>
          <b-form-group id="confirm.state" label="Estado" label-for="confirm.state">
            <b-form-input id="confirm.state" class="bg-soft-info" v-model="confirm.state" type="text" :class="{ 'is-invalid': $v.confirm.state.$error }" autocomplete="off" readonly="readonly"
              v-mask="'XX'"></b-form-input>
            <div v-if="$v.confirm.state.$error" class="invalid-feedback">
              <span v-if="!$v.confirm.state.required">O estado é obrigatório.</span>
            </div>
          </b-form-group>

          <button class="btn btn-default btn-lg btn-block" :disabled="this.confirm.loading">
            Confirmar
            <b-spinner v-if="confirm.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
          </button>
          <a class="btn btn-outline-link mt-4" v-on:click="confirm.modal = false">Fechar</a>
        </b-form>
      </div>
    </b-modal>
  </Layout>
</template>

<style>
.package-disabled {
  opacity: 0.7;
  pointer-events: none;
  filter: grayscale(80%);
  cursor: not-allowed;
}
.package-type .custom-control-label::before {
  top: 19px;
  left: -8px;
}.package-type .custom-control-label::after {
  top: 19px;
  left: -8px;
}
.package-type .custom-control-label {
  cursor: pointer;
  padding: 15px 20px 15px 18px !important;
  font-size: 16px;
}
</style>